<template>
    <section>
        <div class="modal-card" style="width: 1280px; max-width: 100%;">
            <header class="modal-card-head">
                <p class="modal-card-title">Composición Por Año Proyectos</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">

                <div class="columns is-centered">
                    <div class="column">

                        <b-table :data="composition" :paginated="true" per-page="10" striped hoverable
                            :pagination-simple="false" pagination-active-color="hsl(0, 0%, 0%)"
                            pagination-position="bottom" default-sort-direction="asc" sort-icon="arrow-up"
                            aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                            aria-current-label="Página actual">

                            <b-table-column field="name" label="Nombre Proyecto" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Proyecto..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.name }}
                                </template>
                            </b-table-column>

                            <b-table-column field="code" label="Código" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Código..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.code }}
                                </template>
                            </b-table-column>

                            <b-table-column field="project_type" label="Tipo de Proyecto" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Tipo..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.project_type }}
                                </template>
                            </b-table-column>

                            <b-table-column field="start_date" label="Fecha Inicio" sortable searchable
                                :custom-search="searchCustomProjectStartDate">
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]"
                                        placeholder="Buscar Fecha Incio..." icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.start_date._isValid ? new Date(props.row.start_date).toLocaleDateString("es-CL") : '' }}
                                </template>
                            </b-table-column>

                            <b-table-column field="id" width="100" label="Acciones" v-slot="props" size="is-small">
                                <b-button pack="fas" icon-right="eye" type="is-info" tag="a"
                                    :href="/projects/ + props.row.id" target="_blank" />
                            </b-table-column>

                        </b-table>

                    </div>
                </div>

            </section>

            <footer class="modal-card-foot">
                <b-button label="Cerrar" @click="$emit('close')" />
            </footer>

        </div>
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import axios from 'axios'
import moment from "moment"
import {searchDate} from "../../packs/utilities"
export default {

    name: 'modal_composition_by_year_project',

    props: [
        'minYear', 'maxYear', 'unitId',
    ],

    data() {
        return{
            isLoading: false,
            composition: [],
        }
    },

    async created() {
        await this.getCompositionFing37()
    },

    methods: {

        async getCompositionFing37() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-composition-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing37',
                    }
                })
                .then(response => {
                    this.composition = response.data

                    this.composition.forEach(project => {
                        var newProject = project
                        newProject.start_date = moment(newProject.start_date, ["YYYY-MM-DD","DD-MM-YYYY"])
                        return newProject
                    })
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        searchCustomProjectStartDate (row, input) {
            return searchDate (row.start_date, input)
        },

    },

}
</script>